/**
 * Operation Management Module Constants
 */

// --- Maintenance Tasks ---
export const MAINTENANCE_TASKS_LIST_URL = '/api/TaskManagement/MaintenanceTasks';
export const MAINTENANCE_TASK_DETAIL_URL = '/api/MaintenanceTasks';
